// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  background-color: #f4f6f8;
  height: 100%;
}
body #toolbarViewer {
  display: none !important;
}

a {
  text-decoration: none;
}

#root {
  height: 100%;
}

.MuiAlert-message-294 {
  margin: 0 auto;
}

.MuiFormGroup-root-518 {
  flex-direction: row !important;
}

.MuiSelect-select.MuiSelect-select {
  width: 150px !important;
}

.MuiTypography-h1 {
  font-weight: 700 !important;
}

.pick-template input[type=file] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 8px 0px 8px;
  margin: 0px 20px 5px 20px;
  cursor: pointer;
}

.selected {
  border: 2px solid #670b4e !important;
}

.MuiTableCell-root-768 {
  text-align: center !important;
}

.MuiTableCell-root-770 {
  text-align: center !important;
}

.MuiDropzoneArea-root {
  min-height: 180px !important;
  border-color: #b3b3b3 !important;
}

.MuiDropzonePreviewList-root {
  display: flex !important;
  justify-content: center !important;
}

.my-button {
  background-color: #0077cc !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/index.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,YAAA;EACA,mCAAA;EACA,kCAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;AACE;EACE,wBAAA;AACJ;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EAEE,sBAAA;EACA,qBAAA;EACA,wBAAA;EACA,yBAAA;EACA,eAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,4BAAA;EACA,gCAAA;AADF;;AAIA;EACE,wBAAA;EACA,kCAAA;AADF;;AAIA;EACE,oCAAA;AADF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  background-color: #f4f6f8;\n  height: 100%;\n\n  #toolbarViewer {\n    display: none !important;\n  }\n}\n\na {\n  text-decoration: none;\n}\n\n#root {\n  height: 100%;\n}\n\n.MuiAlert-message-294 {\n  margin: 0 auto;\n}\n\n.MuiFormGroup-root-518 {\n  flex-direction: row !important;\n}\n\n.MuiSelect-select.MuiSelect-select {\n  width: 150px !important;\n}\n\n.MuiTypography-h1 {\n  font-weight: 700 !important;\n}\n\n.pick-template input[type=\"file\"] {\n  display: none;\n}\n\n.custom-file-upload {\n  // background-color: #cccccc;\n  border: 1px solid #ccc;\n  display: inline-block;\n  padding: 6px 8px 0px 8px;\n  margin: 0px 20px 5px 20px;\n  cursor: pointer;\n}\n\n.selected {\n  border: 2px solid #670b4e !important;\n}\n\n.MuiTableCell-root-768 {\n  text-align: center !important;\n}\n\n.MuiTableCell-root-770 {\n  text-align: center !important;\n}\n\n.MuiDropzoneArea-root {\n  min-height: 180px !important;\n  border-color: #b3b3b3 !important;\n}\n\n.MuiDropzonePreviewList-root {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.my-button {\n  background-color: #0077cc !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
